import api from "../api/config";

export const paytrService = {
  // PayTR iframe token oluştur
  createIframeToken: async (orderData) => {
    try {
      console.log("PayTR iframe token oluşturuluyor:", orderData);
      
      // PayTR'ye gönderilecek parametreler
      // Backend'de hash hesaplaması yapılacak
      const paytrData = {
        orderId: orderData.orderId.toString(),
        email: orderData.email,
        amount: orderData.amount,
        installment: orderData.installment || "0",
        use3DSecure: orderData.use3DSecure,
        userName: orderData.userName || "",
        userAddress: orderData.userAddress || "",
        userPhone: orderData.userPhone || "",
        basket: orderData.basket || [],
        cardName: orderData.cardName,
        cardNumber: orderData.cardNumber,
        expiryMonth: orderData.expiryMonth,
        expiryYear: orderData.expiryYear,
        cvv: orderData.cvv
      };
      
      // API'ye gönder - Backend hash hesaplamasını yapacak
      const response = await api.post("/api/v3/payment/paytr/create-payment", paytrData);
      
      console.log("PayTR iframe token yanıtı:", response);
      
      if (response.status === "success" && response.token) {
        return {
          success: true,
          token: response.token,
          iframeUrl: `https://www.paytr.com/odeme/guvenli/${response.token}`
        };
      } else if (response.iframe_token) {
        // Alternatif response formatı
        return {
          success: true,
          token: response.iframe_token,
          iframeUrl: `https://www.paytr.com/odeme/guvenli/${response.iframe_token}`
        };
      } else {
        throw new Error(response.reason || response.message || "PayTR token oluşturulamadı.");
      }
      
    } catch (error) {
      console.error("PayTR iframe token hatası:", error);
      throw new Error(error.message || "Ödeme işlemi başlatılamadı.");
    }
  },
  
  // Ödeme durumunu kontrol et
  checkPaymentStatus: async (orderId) => {
    try {
      const response = await api.get(`/api/v3/payment/status/${orderId}`);
      return response;
    } catch (error) {
      console.error("Ödeme durumu kontrol hatası:", error);
      throw error;
    }
  },
  
  // Ödeme callback'ini işle (webhook için)
  handlePaymentCallback: async (callbackData) => {
    try {
      // PayTR'den gelen callback'i doğrula
      const response = await api.post("/api/v3/payment/paytr/callback", callbackData);
      return response;
    } catch (error) {
      console.error("PayTR callback hatası:", error);
      throw error;
    }
  }
};

export default paytrService;